import styled from 'styled-components';

export const Wrapper = styled.div`
  min-height: 412px;
  background: #2253f5;
  color: #ffffff;

  font-family: 'Montserrat', sans-serif;
  h1,
  h2,
  h3,
  p {
    margin: 0;
  }

  div.hero-1 {
    max-width: 740px;
    text-align: center;
    margin: 0 auto;
    padding-top: 45px;

    h1 {
      font-size: 48px;
      line-height: 56px;
    }

    p {
      max-width: 620px;
      margin: 30px auto;

      font-family: Source Sans Pro;
      font-weight: 300;
      font-size: 24px;
      line-height: 32px;

      color: #ffffff;
    }

    @media (max-width: 768px) {
      max-width: 320px;
      padding-top: 40px;

      h1 {
        font-size: 24px;
        line-height: 32px;
      }

      p {
        max-width: 300px;
        margin: 20px auto;

        font-size: 18px;
        line-height: 24px;
      }
    }
  }

  div.apps {
    width: 100%;
    height: 200px;
    background: url('/iconeshome.png') center repeat-x;

    @media (max-width: 768px) {
      height: 65px;
      background: url('/iconeshome.png') top repeat-x;
    }
  }
`;

export const Container = styled.div`
  margin-top: -22.8rem;
  padding: 6.375rem 1rem;

  @media (max-width: 768px) {
    margin-top: -23rem;
  }
`;

export const Content = styled.main`
  max-width: 1000px;
  max-height: 594px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  background: #fff;
  border-radius: 40px;
  border: 1px solid #cfd3de;
  margin: 0 auto;
  padding: 4rem 1rem;

  box-shadow: 0px 6px 30px rgba(155, 155, 155, 0.12),
    0px 8px 10px rgba(18, 21, 64, 0.04);
`;

export const Button = styled.button`
  width: 562px;
  height: 100px;
  cursor: pointer;

  background: #f5f8ff;
  font-family: Montserrat;
  color: #333333;
  font-size: 1.3rem;

  border: 1px solid #e8eaef;
  border-radius: 15px;

  transition: border 0.3s;

  &:hover {
    border: 1px solid #2253f5;
    box-shadow: 0px 2px 15px rgba(100, 114, 140, 0.25);
  }

  & + Button {
    margin-top: 2.875rem;
  }

  @media (max-width: 768px) {
    max-width: 265px;
  }
`;
